const productForm = (element) => element.closest('.shopify-section')?.querySelector('form[data-type="add-to-cart-form"]')

// Dawn renders the quantity selector outside the form and links it with the form attribute.
const quantityInputs = (form) => {
  const inputs = [...form.elements].filter((element) => element.name === 'quantity')
  if (inputs.length) return inputs
  const hidden = Object.assign(document.createElement('input'), { type: 'hidden', name: 'quantity' })
  form.append(hidden)
  return [hidden]
}

const press = (buttons, selected) => buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === selected)))

if (!customElements.get('theme-countdown')) {
  customElements.define('theme-countdown', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController()
      this.output = this.querySelector('[data-countdown]')
      this.tick = () => {
        const end = Date.parse(this.dataset.end.replace(' ', 'T'))
        const remaining = end - Date.now()
        if (!Number.isFinite(end) || remaining <= 0) {
          this.output.replaceChildren(this.dataset.ended || '')
          return
        }
        const parts = { days: Math.floor(remaining / 86400000), hours: Math.floor(remaining / 3600000) % 24, minutes: Math.floor(remaining / 60000) % 60, seconds: Math.floor(remaining / 1000) % 60 }
        this.output.replaceChildren()
        const visibleParts = Object.entries(parts).filter(([unit]) => this.dataset[unit] === 'true')
        for (const [index, [unit, value]] of visibleParts.entries()) {
          if (index > 0 && this.dataset.separators === 'true') {
            const separator = document.createElement('span')
            separator.className = 'theme-countdown__separator'
            separator.setAttribute('aria-hidden', 'true')
            separator.textContent = ':'
            this.output.append(separator)
          }
          const item = document.createElement('span')
          item.className = 'theme-countdown__item'
          const number = document.createElement('strong')
          const label = document.createElement('small')
          number.textContent = String(value).padStart(2, '0')
          label.className = 'theme-countdown__label'
          label.textContent = this.dataset[`${unit}Label`] || unit
          item.append(number, label)
          this.output.append(item)
        }
        this.timer = setTimeout(this.tick, 1000)
      }
      this.tick()
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort() }
  })
}

const advanceDelivery = (date, skipSaturday, skipSunday) => {
  const next = new Date(date)
  next.setDate(next.getDate() + 1)
  while ((skipSunday && next.getDay() === 0) || (skipSaturday && next.getDay() === 6)) next.setDate(next.getDate() + 1)
  return next
}

if (!customElements.get('theme-delivery')) {
  customElements.define('theme-delivery', class extends HTMLElement {
    connectedCallback() {
      const target = this.querySelector('[data-delivery-output]')
      if (!target) return
      let cursor = new Date()
      if (cursor.getHours() >= Number(this.dataset.cutoff || 14)) cursor = advanceDelivery(cursor, this.dataset.saturday === 'true', this.dataset.sunday === 'true')
      const add = (days) => {
        let value = new Date(cursor)
        for (let index = 0; index < days; index += 1) value = advanceDelivery(value, this.dataset.saturday === 'true', this.dataset.sunday === 'true')
        return new Intl.DateTimeFormat(this.dataset.locale || undefined, { weekday: 'short', day: 'numeric', month: 'short' }).format(value)
      }
      target.textContent = (this.dataset.template || '').replace('[start]', add(Number(this.dataset.min || 0))).replace('[end]', add(Number(this.dataset.max || 0)))
    }
  })
}

if (!customElements.get('theme-popup')) {
  customElements.define('theme-popup', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController()
      const dialog = this.querySelector('dialog')
      this.querySelector('[data-popup-open]')?.addEventListener('click', () => dialog?.showModal(), { signal: this.controller.signal })
      this.querySelector('[data-popup-close]')?.addEventListener('click', () => dialog?.close(), { signal: this.controller.signal })
      dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close() }, { signal: this.controller.signal })
    }
    disconnectedCallback() { this.controller?.abort() }
  })
}

if (!customElements.get('theme-stories')) {
  customElements.define('theme-stories', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController()
      this.addEventListener('click', (event) => {
        const open = event.target.closest('[data-story-open]')
        if (open) this.querySelector(`#${CSS.escape(open.getAttribute('aria-controls'))}`)?.showModal()
        if (event.target.closest('[data-story-close]')) event.target.closest('dialog')?.close()
        if (event.target.matches('dialog')) event.target.close()
      }, { signal: this.controller.signal })
    }
    disconnectedCallback() { this.controller?.abort() }
  })
}

if (!customElements.get('theme-quantity-breaks')) {
  customElements.define('theme-quantity-breaks', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController()
      this.buttons = [...this.querySelectorAll('[data-quantity]')]
      this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button), { signal: this.controller.signal }))
      if (this.buttons[0]) this.select(this.buttons[0])
    }
    select(button) {
      press(this.buttons, button)
      const form = productForm(this)
      if (!form) return
      for (const input of quantityInputs(form)) { input.value = button.dataset.quantity; input.dispatchEvent(new Event('change', { bubbles: true })) }
    }
    disconnectedCallback() { this.controller?.abort() }
  })
}

if (!customElements.get('theme-subscription')) {
  customElements.define('theme-subscription', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController()
      this.buttons = [...this.querySelectorAll('[data-selling-plan]')]
      this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button), { signal: this.controller.signal }))
      const initial = this.buttons.find((button) => button.dataset.selected === 'true') || this.buttons[0]
      if (initial) this.select(initial)
    }
    select(button) {
      press(this.buttons, button)
      const form = productForm(this)
      if (!form) return
      let input = form.querySelector('input[name="selling_plan"]')
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'selling_plan'; form.append(input) }
      input.disabled = button.dataset.sellingPlan === ''
      input.value = button.dataset.sellingPlan
    }
    disconnectedCallback() { this.controller?.abort() }
  })
}
